










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Post extends Vue {
  // data
  userName: string = '';
  content: string = '';

  // lifecycle
  created() {
    if (localStorage.userName) this.userName = localStorage.userName;
  }

  // computed
  get postUser(): string {
    if (this.userName === '') {
      return 'you';
    }
    return this.userName;
  }

  // methods
  postTweet(): void {
    if (this.content === '') {
      return;
    }

    this.$emit(
      'postTweet',
      this.postUser,
      require('../assets/icon/you.jpg'),
      this.content,
      true,
    );

    if (this.userName) localStorage.userName = this.userName;
    this.content = '';
  }
}
